
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-arrow';
      import '@folkjs/labs/standalone/folk-spreadsheet';

      let isProjected = false;
      const button = document.querySelector('button');

      button.addEventListener('click', () => {
        isProjected = !isProjected;

        document.startViewTransition(() => {
          isProjected ? addOverlayGraph() : removeOverlayGraph();
        });
      });

      function addOverlayGraph() {
        document.body.setAttribute('overlay', '');

        document.querySelectorAll('folk-cell').forEach((cell) => {
          if (cell.dependencies.length === 0) return;

          cell.setAttribute('graph', '');

          for (const dep of cell.dependencies) {
            dep.setAttribute('graph', '');

            const connection = document.createElement('folk-arrow');
            connection.source = dep;
            connection.target = cell;

            document.body.appendChild(connection);
          }
        });
      }

      function removeOverlayGraph() {
        document.body.removeAttribute('overlay', '');

        document.querySelectorAll('folk-arrow').forEach((arrow) => arrow.remove());

        document.querySelectorAll('folk-cell').forEach((cell) => {
          cell.removeAttribute('graph', '');
        });
      }
    